const pctIncrease = (oldval, newval) => {
  const pct = Math.round((100 * (oldval - newval)) / newval);
  if (Number.isNaN(pct) || !Number.isFinite(pct)) return null;
  return pct;
};
export default pctIncrease;
